/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api/selectitem';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { Tab } from '../../../core/model/tab.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { UserService } from '../../../core/services/user.service';


/**
 * @export
 * @class LmsLocoInformationComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-information',
  templateUrl: './lms-loco-information.component.html',
  styleUrls: ['./lms-loco-information.component.scss']
})
export class LmsLocoInformationComponent implements OnInit, OnDestroy, OnChanges {

  @Input() locoData: LocoDetail;
  @Input() locoLabel: any;
  @Input() tab: Tab;
  @Input() group: any;
  @Input() errorMap: Map<string, boolean>;
  locoInfoForm: UntypedFormGroup;
  locoDirection: SelectItem[];
  classValue: SelectItem[];

  /**
   * Creates an instance of LmsLocoInformationComponent.
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {AppUtilityService} appUtilityService
   *
   * @memberOf LmsLocoInformationComponent
   */
  constructor(private staticDataStoreService: StaticDataStoreService, private appUtilityService: AppUtilityService, 
    public user: UserService) {
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    this.locoDirection = [];
    this.locoDirection.push({
      label: 'Select',
      value: ''
    });
    this.locoDirection.push({
      label: 'Unknown',
      value: ' '
    });
    this.locoDirection.push({
      label: 'Forward',
      value: 'F'
    });
    this.locoDirection.push({
      label: 'Backward',
      value: 'B'
    });
    this.classValue = [];
    if (commonopsPicklist && commonopsPicklist.masterData) {
      if (commonopsPicklist.masterData.classCodeList && commonopsPicklist.masterData.classCodeList.length > 0) {
        this.classValue.push({
          label: 'Select',
          value: ''
        });
      }
      for (let i = 0; i < commonopsPicklist.masterData.classCodeList.length; i++) {
        this.classValue.push({
          label: commonopsPicklist.masterData.classCodeList[i],
          value: commonopsPicklist.masterData.classCodeList[i]
        });
      }
    }
  }

  /**
   * @memberOf LmsLocoInformationComponent
   */
  ngOnInit() {

  }

  /**
   * @memberOf LmsLocoInformationComponent
   */
  ngOnChanges() {
    if (this.tab.mode === 'edit') {
      this.locoInfoForm = this.group;
    }
  }

  /**
   * @memberOf LmsLocoInformationComponent
   */
  ngOnDestroy() {
  }

  /**
   * This method returns dash only when all the values given are null or blank
   * @param {string[]} value
   * @returns
   * @memberOf LmsLocoInformationComponent
   */
  returnDash(value: string[]) {
    let isBlank: boolean;
    for (let i = 0; i < value.length; i++) {
      if (value[i]) {
        isBlank = false;
        break;
      } else {
        isBlank = true;
      }
    }
    return isBlank;
  }
}
